export default __webpack_public_path__ + "static/media/FTML.14476c74.svg";